export default function ContractIco() {
  return (
    <svg
      width="10"
      height="15"
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.241 -0.000175203C4.5804 -0.000695203 4.8816 -0.00115519 5.1598 0.11408C5.438 0.229315 5.6507 0.442635 5.8903 0.683C6.3651 1.15925 6.84065 1.63479 7.3169 2.10959C7.55725 2.34921 7.7706 2.56188 7.8858 2.84008C8.00105 3.11829 8.0006 3.41951 8.00005 3.75891C7.99815 5.01688 8 6.27483 8 7.53283C8.00005 7.97608 8.00005 8.35798 7.95895 8.66378C7.91485 8.99153 7.8155 9.30573 7.56065 9.56058C7.30585 9.81538 6.99165 9.91478 6.6639 9.95883C6.35805 9.99993 5.97615 9.99993 5.5329 9.99988H2.4671C2.02385 9.99993 1.64194 9.99993 1.33611 9.95883C1.00835 9.91478 0.694176 9.81538 0.439341 9.56058C0.184511 9.30573 0.0851412 8.99153 0.0410762 8.66378C-4.37871e-05 8.35798 -2.37764e-05 7.97608 1.22358e-06 7.53283L6.23037e-06 2.4999C6.23037e-06 2.48889 1.22358e-06 2.47791 1.22358e-06 2.46698C-2.37764e-05 2.02374 -4.37871e-05 1.64183 0.0410762 1.336C0.0851412 1.00824 0.184511 0.69407 0.439346 0.43924C0.694176 0.184405 1.00835 0.0850348 1.33611 0.0409698C1.64194 -0.000150178 2.02385 -0.000130167 2.46709 -0.000105167C3.0584 -7.01672e-05 3.6497 0.000734797 4.241 -0.000175203Z"
        fill="#00CEAC"
      />
    </svg>
  );
}
